import reporter from './reporter'
import locale from './locale'

export default {
  // serverUrl: 'https://d28ag1ebuf0g4e.cloudfront.net/', // prd
  serverUrl: process.env.SERVER_URL, // dev
  //serverUrl: 'https://api-doss.depa.or.th/', //dev-depa
  techhuntUrl: process.env.TECHHUNT_URL, // prd
  // techhuntUrl: 'https://techhunt.zwiz.ai/', // dev
  facebookUrl: 'https://graph.facebook.com/',
  depaApi: process.env.DEPA_API,
  appid: process.env.FACEBOOK_APP_ID,
  liff: process.env.LIFF_URL, // prd
  // liff: 'https://depa.zwiz.ai/', // dev
  thaid_client_id: process.env.THAID_CLIENT_ID,
  thaid_redirect_uri: process.env.THAID_REDIRECT_URI,
  thaid_URL: 'https://imauth.bora.dopa.go.th/api/v2/oauth2/auth',
  azure_client_id: process.env.AZURE_CLIENT_ID,
  azure_redirect_uri: process.env.AZURE_REDIRECT_URI,
  azure_tenant_id: process.env.AZURE_TENANT_ID,

  // ปิดการ login ด้วย username/password ไว้ก่อน (เก็บโค้ดไว้ทั้งหมด แค่ซ่อน UI)
  // ต้องการเปิดกลับมาใช้เมื่อไหร่ ให้เปลี่ยนค่านี้เป็น true
  enable_password_login: false,

  theme: {
    logo: '/static/icon/depadark.png',
    small_logo: '/static/icon/depadark.png',
    short_small_logo: '/static/icon/depadark.png',
    hide_zwiz: false,
    email_contact: 'sales@zwiz.ai',
    header_color: 'white',
    header_background_color: '#504F4F',
    brand_color: '#0C2F53', // #ed1839    Default is #FF706B OLD #152D53
    secondary_color: '#ff687f' // #ff687f
  },

  fb_scope:
    'email,public_profile,manage_pages,pages_messaging,pages_messaging_subscriptions,read_page_mailboxes,publish_pages,page_events',

  reporter: reporter,
  locale: locale.locale,
  // lineNotifyClientId: 'bK3tlzN7s2P7JJidZXxh2u' // production
  lineNotifyClientId: process.env.LINE_NOTIFY_CLIENT_ID,
  recaptcha: process.env.RECAPTCHA_SITEKEY,
  botpressUrl: process.env.BOTPRESS_URL,
}



// WEBPACK FOOTER //
// ./src/config/index.js